import { render, staticRenderFns } from "./AutoRewardsConfirmation.vue?vue&type=template&id=72aa5736"
import script from "./AutoRewardsConfirmation.vue?vue&type=script&lang=js"
export * from "./AutoRewardsConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports